import { IonTextarea } from "@ionic/react";
import React, { useEffect, useState } from "react";
import Loader from "../../../../../../../../components/Shared/Loader/Loader";
import NoResults from "../../../../../../../../components/Shared/NoResults/NoResultsComponent";
import { utilService } from "../../../../../../../../services/utilService";
import {
  DataChanged,
  RespNotesContainerInterface,
} from "./Models/NotesContainer.model";
import { useToast } from "@agney/ir-toast";
import NotesCard from "./components/NotesCard/NotesCard";
import { notesContainerService } from "./NotesContainer.service";
import { statusBoardService } from "../../../../../../StatusBoard.service";
import "./NotesContainer.scss";
import {
  notesCardParams,
  RespNotesCardInterface,
} from "./components/NotesCard/Models/NotesCard.model";
import dayjs from "dayjs";
import { loggedInUserService } from "../../../../../../../../services/loggedInUser.service";
import InfiniteScroll from "react-infinite-scroll-component";
import _ from "lodash";
import { statusBoardSocketService } from "../../../../../../StatusBoardSocketService";
import { useTranslation } from "react-i18next";
interface ContainerProps {
  isNotesUpdated: boolean;
  onNotesUpdated: () => void;
}
const NotesContainer: React.FC<ContainerProps> = (props) => {
   const { t } = useTranslation("statusBoard");
  const [textData, setTextData]: any = useState("");
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [notesNextValue, setNotesNextValue]: any = useState("");
  var [notesContainerData, setNotesContainerData]: any = useState([]);
  var [userDetails, setUserDetails]: any = useState();
  const Toast = useToast();

  useEffect(() => {
    const subscription = subscribeUserData();
    getNotesContainerListDetails();
    return () => subscription?.unsubscribe();
  }, []);

  useEffect(() => {
    if (props.isNotesUpdated) {
      getNotesContainerListDetails();
      props.onNotesUpdated();
    }
  }, [props.isNotesUpdated]);

  const subscribeUserData = () => {
    const subscription = loggedInUserService.getLoggedInUserData.subscribe(
      (data: any) => {
        if (data) {
          setUserDetails(data);
        }
      }
    );
    // Returns the subscription, not an unbound `unsubscribe` method.
    return subscription;
  };

  async function searchNext($event: CustomEvent<void>) {
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function getNotesContainerListDetails(page: number = 1) {
    setLoaderStatus(true);
    const params: any = getNoteParams(page);

    const respNotesContainerResult: RespNotesContainerInterface =
      await notesContainerService.getNotesContainerList(params);
    if (
      respNotesContainerResult.isSuccess &&
      respNotesContainerResult.displayNotesContainer.length
    ) {
      setNotesNextValue(respNotesContainerResult.displayNotesContainer[0].next);
      if (pageNo === 1) {
        setNotesContainerData(
          _.cloneDeep(respNotesContainerResult?.displayNotesContainer[0].data)
        );
      } else {
        setNotesContainerData([
          ...notesContainerData,
          ...respNotesContainerResult?.displayNotesContainer[0].data,
        ]);
      }
      // setPageNo(pageNo + 1);
    } else {
      notesContainerService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  async function getNotesCardListDetails(addParams: notesCardParams) {
    setLoaderStatus(true);
    const respNotesCardResult: RespNotesCardInterface =
      await notesContainerService.addNotesCardList(addParams);
    if (respNotesCardResult.isSuccess) {
      setNotesContainerData(_.cloneDeep(respNotesCardResult.displayNotesCard));
      setTextData("");
      const socketParams = {
        type: "notes",
      };
      statusBoardSocketService.sendSbInputSocketParams(socketParams);
     Toast.success(t("noteAddedSuccess"));
    } else {
      notesContainerService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }


  const addNotes = () => {
    const date = new Date();
    const time = dayjs(date, "h:mm A").format("hh:mm A");
    const timePickerTime = dayjs(date, "hh:mm:ss").format("HH:mm:ss");
    const addParams = {
      bedId: statusBoardService.rowData.id,
      date_time: dayjs(date).format("MM-DD-YYYY") + " " + time,
      note: textData,
      reg_code: utilService.getNetwork(),
      statusBoardID: statusBoardService.statusBoardId,
      user_name:
        !utilService.isEmpty(userDetails) &&
        userDetails.userData &&
        userDetails.userData.firstName
          ? userDetails.userData.firstName
          : "",
    };
    getNotesCardListDetails(addParams);
  };

  const getNoteParams = (page: any) => {
    return {
      bedId: statusBoardService.rowData.id,
      statusBoardID: statusBoardService.statusBoardId,
      reg_code: utilService.getNetwork(),
      page: page,
    };
  };

  const onScroll = () => {
    if (!_.isEmpty(notesNextValue)) {
      setPageNo(pageNo + 1);
      getNotesContainerListDetails(pageNo + 1);
    }
  };

  return (
    <div className="sboard-notes-container">
      <div className="sboard-notes-wrapper">
        <div className="notes-header-wrapper">
         <div className="notes-heading">{t("notes")}</div>
        </div>
        <div className="text-area-wrapper">
          <IonTextarea
            className="text-area-wrap"
            value={textData}
            onIonChange={(event) => setTextData(event.detail.value!)}
            maxlength={300}
            placeholder={t("typeNotes")}
          ></IonTextarea>
          <span className="characterWarning">
            {300 - textData?.length} {t("charactersLeft")}
          </span>
          <div
            className="icon-add note-send-button"
            onClick={() => addNotes()}
          ></div>
        </div>

        <div className="prev-notes-container">
          {notesContainerData && (
            <div className="notes-list-div">
              {isLoaderActive && (
                <div className="loader-container">
                  <Loader></Loader>
                </div>
              )}

              <InfiniteScroll
                dataLength={notesContainerData.length}
                height={570}
                next={() => onScroll()}
                hasMore={true}
                loader={<div></div>}
              >
                <div className="inner-grid image-wrapper">
                  <div className="heading">
                    {notesContainerData && notesContainerData.length > 0
                      ? notesContainerData.map(
                          (item: DataChanged, index: number) => {
                            return (
                              <NotesCard
                                key={index}
                                notesData={item}
                                setNotesContainerData={setNotesContainerData}
                              ></NotesCard>
                            );
                          }
                        )
                      : [
                          !isLoaderActive && (
                            <span key={""}>
                              <NoResults></NoResults>
                            </span>
                          ),
                        ]}
                  </div>
                </div>
              </InfiniteScroll>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotesContainer;
